import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'

const defaultStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    overflowX: 'scroll',
    paddingBottom: theme.spacing(1),
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  image: {
    margin: '10px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    width: '255px',
    height: '200px',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
  },
}))

const ImageSelectionInput = ({ imageUrls, value, onChange, classes = {} }) => {
  const defaultClasses = defaultStyles()
  return (
    <Box className={`${defaultClasses.root} ${classes.root ?? ''}`}>
      {imageUrls.map(imageUrl => {
        const isSelected = value === imageUrl
        return (
          <Box
            key={imageUrl}
            className={`${
              defaultClasses.imageContainer
            } ${classes.imageContainer ?? ''}`}
          >
            <Box
              className={`
                ${defaultClasses.image} ${classes.image ?? ''}
                ${
                  value === imageUrl
                    ? `${
                      defaultClasses.selectedImage
                    } ${classes.selectedImage ?? ''}`
                    : ''
                }
              `}
              style={{ backgroundImage: `url(${imageUrl})` }}
              onClick={() => onChange(imageUrl)}
            />
            <Button
              disabled={isSelected}
              variant="contained"
              color="primary"
              onClick={() => onChange(imageUrl)}
            >
              {isSelected ? 'Selected' : 'Select'}
            </Button>
          </Box>
        )
      })}
    </Box>
  )
}

export default ImageSelectionInput
